// extracted by mini-css-extract-plugin
module.exports = {"bannerProperties":"BannerProperties_bannerProperties__dV_w_"};